<template>
  <div>
    <b-table
      class="custom-table"
      responsive
      :items="projectUsers"
      :fields="userFields"
    >
      
      <template #cell()="data">
        <span v-if="data.value == ''">--</span>
        <span v-else>{{ data.value }}</span>
      </template>
      <template v-slot:cell(name)="data">
        <span>{{ data.value }}</span>
        <span
          v-if="data.item.permissionLevel === 'Admin'"
          class="pl-1"
        >
          <b-icon-asterisk 
            font-scale="0.6" 
            shift-v="14"
            variant="danger"
          >
          </b-icon-asterisk>
        </span>
      </template>
      <!-- <template v-slot:cell(permissionLevel)="data">
        <b-badge
          v-if="data.item.permissionLevel === 'Sponsor'"
          variant="primary"
        >
          Executive
        </b-badge>
        <b-badge
          v-else-if="data.item.permissionLevel === 'Admin'"
          variant="danger"
        >
          Admin
        </b-badge>
        <b-badge
          v-else-if="data.item.permissionLevel === 'Respondent'"
          variant="warning"
        >
          Respondent
        </b-badge>
      </template> -->
      <template #cell(sendSurvey)="data">
        <span v-if="data.value == true">
          <b-icon icon="check2" aria-label="Yes" title="Yes">Yes</b-icon>
        </span>
        <span v-else>
          <b-icon icon="x" aria-label="No" title="No">No</b-icon>
        </span>
      </template>
      <template #cell(email)="data">
        <span class="user__email">{{ data.value }}</span>
      </template>
      <template #cell(contactMethods)="data">
        <span
          v-if="
            data.value &&
            data.value.includes('phone') &&
            data.value.includes('email')
          "
        >
          <b-icon icon="telephone-fill" aria-label="Phone" title="Phone">
            Phone
          </b-icon>
          /
          <b-icon icon="envelope-fill" aria-label="E-mail" title="E-mail">
            E-mail
          </b-icon>
        </span>
        <span v-else-if="data.value == 'phone'">
          <b-icon icon="telephone-fill" aria-label="Phone" title="Phone">
            Phone
          </b-icon>
        </span>
        <span v-else-if="data.value == 'email'">
          <b-icon icon="envelope-fill" aria-label="E-mail" title="E-mail">
            E-mail
          </b-icon>
        </span>
        <span v-else>--</span>
      </template>
      <template #cell(passwordStatus)="data">
        <span v-if="data.item.passwordStatus == 'Set up'">
          <b-icon icon="check2" aria-label="Yes" title="Yes">Yes</b-icon>
        </span>
        <span v-else>
          <b-icon icon="x" aria-label="No" title="No">No</b-icon>
        </span>
      </template>
      <template #cell(approveCharterDate)="data">
        <span v-if="data.item.approveCharterDate">
          <b-icon icon="check2" aria-label="Yes" title="Yes">Yes</b-icon>
        </span>
        <span v-else>
          <b-icon icon="x" aria-label="No" title="No">No</b-icon>
        </span>
      </template>
      <template #cell(organization)="data">
        <img
          v-if="data.item.organizationLogo"
          :src="data.item.organizationLogo"
          class="table-logo"
          :alt="data.item.organization"
          :title="data.item.organization"
        />
        <span v-else>
          {{ data.item.organization }}
        </span>
      </template>
      <!-- <template #cell(actions)>
      <b-button class="additional-btn kebab">
        <b-icon class="icon kebab" icon="three-dots-vertical" font-scale="1"></b-icon>
      </b-button>
    </template> -->
      <template #cell(kebab)="data">
        <b-overlay :show="inProgressUsers.includes(data.item.userId)" >
          <b-dropdown
            id="dropdown-1"
            class="kebab"
            text="Additional Options"
            variant="tertiary"
            no-caret
            offset="-125"
          >
            <template #button-content>
              <b-icon
                class="icon kebab additional"
                icon="three-dots-vertical"
                font-scale="1"
              ></b-icon
              ><span class="sr-only">Additional Options</span>
            </template>
            <b-dropdown-item @click="editUser(data.item.userId)">
              Edit
            </b-dropdown-item>
            <b-dropdown-item @click="removeUser(data.item.userId)">
              Remove
            </b-dropdown-item>
            <b-dropdown-item v-if="data.item.passwordStatus != 'Set up'" @click="resendInvite(data.item.userId)">
              Send Invite
            </b-dropdown-item>
            <b-dropdown-item v-if="!data.item.approveCharterDate" @click="approveCharter(data.item.userId, data.item.userCharterId)">
              Approve Charter
            </b-dropdown-item>
            <b-dropdown-item v-if="data.item.sendSurvey && data.item.responseData == null" @click="sendSurvey(data.item.userId)">
              Send Survey
            </b-dropdown-item>
          </b-dropdown>
        </b-overlay>
      </template>
    </b-table>
    <p>
      <b-icon-asterisk 
        font-scale="0.6" 
        shift-v="4"
        variant="danger"
      >
      </b-icon-asterisk>
      <span> = users with admin permission levels</span>
    </p>
    <EditProjectUserModal
      ref="edit-user-modal"
      mode="Edit"
      :projectUser="editingUser"
      :projectId="projectId"
      @submit="onEditUserSubmit"
    >
    </EditProjectUserModal>
    <BaseConfirmationModal
      ref="remove-user-modal"
      title="Remove Confirmation"
      message="Are you sure you want to remove this user from the project?"
      okText="Yes, I'm sure"
      @submit="onRemoveUserConfirmed"
    >
    </BaseConfirmationModal>
  </div>
</template>

<script>
import axios from "axios";
import EditProjectUserModal from "@/components/modals/EditProjectUserModal.vue";
import BaseConfirmationModal from "@/components/BaseConfirmationModal.vue";

export default {
  props: {
    projectUsers: {
      type: Array,
      required: true,
    },
    projectId: { type: String, default: "", required: true },
  },
  components: {
    EditProjectUserModal,
    BaseConfirmationModal,
  },
  data() {
    return {
      loading: false,
      editingUser: null,
      deletingUser: null,
      inProgressUsers: [],
      userFields: [
        { key: "name", label: "Name", sortable: true },
        { key: "jobTitle", label: "Title" },
        { key: "email", label: "Email" },
        { key: "contactMethods", label: "Contact" },
        { key: "phone", label: "Phone" },
        { key: "organization", label: "Organization", sortable: true },
        // { key: "role", label: "Role", sortable: true },
        // { key: "permissionLevel", label: "Level", sortable: true },
        { key: "sendSurvey", label: "Survey", sortable: true },
        { key: "passwordStatus", label: "Confirmed", sortable: true },
        { key: "approveCharterDate", label: "Charter", sortable: true },
        { key: "kebab", label: "" },
      ],
    };
  },
  methods: {
    refreshUserList() {
      this.$emit("update");
    },
    onEditUserSubmit() {
      (this.editingUser = null), this.refreshUserList();
    },
    editUser(userId) {
      this.editingUser = this.projectUsers.find((u) => u.userId === userId);
      this.$nextTick(() => {
        this.$refs["edit-user-modal"].show();
      });
    },
    removeUser(userId) {
      this.deletingUser = this.projectUsers.find((u) => u.userId === userId);
      this.$refs["remove-user-modal"].show();
    },
    resendInvite(userId){
      this.inProgressUsers.push(userId);
      axios
        .post(`${this.$api_url}/users/${userId}/send-signup-invite`, null, this.getReqConfig())
        .then(() => {
        })
        .catch((err) => {
          this.$emit("error", err);
        })
        .finally(() => {
          this.inProgressUsers = this.inProgressUsers.filter(u => u != userId);
        })
    },
    approveCharter(userId, userCharterId){
      this.inProgressUsers.push(userId);
      axios
        .put(`${this.$api_url}/userCharters/${userCharterId}/approve`, null, this.getReqConfig())
        .then(() => {
          const user = this.projectUsers.find(user => user.userCharterId === userCharterId);
          if (user) {
            user.approveCharterDate = new Date();
          }
        })
        .catch((err) => {
          this.$emit("error", err);
        })
        .finally(() => {
          this.inProgressUsers = this.inProgressUsers.filter(u => u != userId);
        })
    },
    onRemoveUserConfirmed() {
      let userId = this.deletingUser.userId;
      this.removeProjectUser(userId);
    },
    removeProjectUser(userId) {
      this.deletingUser = null;
      let url = `${this.$api_url}/projects/${this.projectId}/users/${userId}/remove`;
      this.inProgressUsers.push(userId);
      axios
        .post(url, null, this.getReqConfig())
        .then(() => {
          this.$emit("update");
        })
        .catch((err) => {
          this.$emit("error", err);
        })
        .finally(() => {
          this.inProgressUsers = this.inProgressUsers.filter(u => u != userId);
        });
    },
    sendSurvey(userId) {
      this.inProgressUsers.push(userId);
      axios
        .post(`${this.$api_url}/projects/${this.projectId}/users/${userId}/send-survey`, null, this.getReqConfig())
        .then(() => {
          this.$emit('update');
        })
        .catch(err => {
          this.$emit('error', err);
        })
        .finally(() => {
          this.inProgressUsers = this.inProgressUsers.filter(u => u != userId);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.user {
  &__email {
    text-overflow: ellipsis;
    display: block;
    overflow: hidden;
  }
}
</style>